module.exports = {"id":"213537","name":"Babacar Sarr","rating":"74","photo":"./data/images/photos/3/213537.png","club":{"name":"Molde FK","logo":"./data/images/clubs/MoldeFK.png"},"positions":["DC","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BabacarSarr0.json
// module id = 515
// module chunks = 0